import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BotaoFocadoFiltroPesquisaDirective, ConteudoPesquisaDirective, FiltroPesquisaDirective, GridPesquisaDirective, ItemFocadoFiltroPesquisaDirective, PesquisaBaseComponent } from './pesquisa-base/pesquisa-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { TabAllModule, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { ButtonAllModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { DateRangePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';



@NgModule({
  declarations: [
    PesquisaBaseComponent,
    FiltroPesquisaDirective,
    ConteudoPesquisaDirective,
    ItemFocadoFiltroPesquisaDirective,
    BotaoFocadoFiltroPesquisaDirective,
    GridPesquisaDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogAllModule,
    ToolbarModule,
    GridAllModule,
    TabAllModule,
    ButtonAllModule,
    TextBoxAllModule,
    DateRangePickerAllModule,
    CheckBoxAllModule,
    SplitButtonAllModule
  ],
  exports: [
    PesquisaBaseComponent,
    FiltroPesquisaDirective,
    ConteudoPesquisaDirective,
    ItemFocadoFiltroPesquisaDirective,
    BotaoFocadoFiltroPesquisaDirective,
    GridPesquisaDirective,
  ]
})
export class PesquisaModule { }
